import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TrainingItemVM } from "@shared-kernel/application/ports/student/student-repository";

export const studentRetrieveAllTrainingItems = createAsyncThunk<TrainingItemVM[], void, { extra: Partial<Dependencies> }>(
  "trainingItems/studentRetrieveAllTrainingItems",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.getAllTrainingItems();
  },
);
